interface ErrorStateProps {
  title?: string
  message?: string
  onRetry?: () => void
}

export default function ErrorState({
  title = 'We could not load this content',
  message = 'Please try again. If the problem continues, contact support.',
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="feedback-state feedback-error" role="alert">
      <span className="feedback-icon"><i className="bi bi-exclamation-triangle" aria-hidden="true" /></span>
      <div>
        <h2>{title}</h2>
        <p>{message}</p>
      </div>
      {onRetry && <button className="btn btn-outline-danger" type="button" onClick={onRetry}>Try again</button>}
    </div>
  )
}
